import React from 'react'

function useEnhancedState<T>(state: T): [T, (updatedValues: Partial<T> | ((state: T) => T)) => void] {
  const [_state, _setState] = React.useState<T>(state)

  const setState = React.useCallback((updatedValues: Partial<T> | ((state: T) => T)) => {
    _setState(typeof updatedValues === 'function' ? updatedValues : (prevState) => ({ ...prevState, ...updatedValues }))
  }, [])

  return [_state, setState]
}

export default useEnhancedState
